module.exports = __webpack_public_path__ + "static/media/savio27.cd75d62d.jpg";